import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BeenhereIcon(props: IconProps) {
    return <Icon {...props} iconKey={"beenhere"}/>
}
